import backCertificate from '../../assets/backgrounds/certificate-back.png';
import frontCertificate from '../../assets/backgrounds/certificate-front.png';
import { ISignaturePartnersGet } from 'interfaces/signature_partners';
import { Flex, Space, Typography } from 'antd';
import clsx from 'clsx';

export interface PreviewCertificateProps {
  signaturePartner: ISignaturePartnersGet;
  type: 'back' | 'front';
}

export const PreviewCertificate = ({
  signaturePartner,
  type
}: PreviewCertificateProps) => {
  const background = type === 'front' ? frontCertificate : backCertificate;

  const FrontSignatures = () => (
    <Flex gap={24} align="end" className="px-6">
      <Flex
        vertical
        gap={0}
        align="center"
        justify="end"
        className="flex-1 h-full"
      >
        <img
          src={signaturePartner.front_signature.signature}
          className="w-full max-w-[200px] h-auto mx-auto"
          alt={signaturePartner.front_signature.name}
        />
        <div className="border solid border-1 border-black w-full" />
        <Typography.Text strong className="!text-[10px]">
          {signaturePartner.front_signature.title}
        </Typography.Text>
      </Flex>
      <Flex vertical gap={0} align="center" justify="end" className="flex-1">
        <img
          src={signaturePartner.back_signature.signature}
          className="w-full max-w-[200px] h-auto mx-auto"
          alt={signaturePartner.back_signature.name}
        />
        <div className="border solid border-1 border-black w-full" />
        <Typography.Text strong className="!text-[10px]">
          {signaturePartner.back_signature.title}
        </Typography.Text>
      </Flex>
    </Flex>
  );

  const BackSignature = () => (
    <Flex
      vertical
      align="center"
      justify="center"
      className="flex-1 w-1/2 h-full mx-auto m-w-[100px]"
    >
      <img
        src={signaturePartner.record_back_signature.signature}
        className="w-[70%] h-auto mx-auto"
        alt={signaturePartner.record_back_signature.name}
      />
      <div className="border solid border-1 border-black w-full" />
      <Typography.Text strong className="!text-[10px]">
        {signaturePartner.record_back_signature.title}
      </Typography.Text>
    </Flex>
  );

  return (
    <Flex
      vertical
      align="stretch"
      className="border w-full h-full rounded overflow-hidden p-3 bg-white"
    >
      <img src={background} className="w-full z-0 mx-auto" alt="background" />
      {type === 'front' && <FrontSignatures />}
      {type === 'back' && <BackSignature />}
    </Flex>
  );
};
